import { createFileRoute } from "@tanstack/react-router";
import { useAdminAuth } from "@/features/admin/hooks/useAdminAuth";
import { HistoricalStatsAdminPanel } from "@/features/admin/historical-stats/components/HistoricalStatsAdminPanel";
import { AdminPageHeader } from "@/features/admin/shell/AdminPageHeader";
import { AdminShell } from "@/features/admin/shell/AdminShell";

export const Route = createFileRoute("/_adminGuarded/admin/historical-stats")({
  component: AdminHistoricalStatsPage,
});

function AdminHistoricalStatsPage() {
  const { state } = useAdminAuth();
  const token = state.status === "authenticated" ? state.token : null;

  return (
    <AdminShell breadcrumbs={[{ label: "Historical stats" }]}>
      <AdminPageHeader
        title="Historical stats"
        subtitle="Manual KNBSB yearly totals for draft context and player profiles."
      />
      <HistoricalStatsAdminPanel token={token} />
    </AdminShell>
  );
}
